import { OrderProduct } from '../../../../../clients/quipli-service/order/order';
import { Field } from '../../../../../components/field/field';
import { Typography } from '../../../../../components/typography/typography';

export const InventoryReturnFuelChargeInput = ({
  fuelAmount,
  setFuelAmount,
  readingsDisabled = false,
  fuelUnit = 'Gallons',
}: {
  orderProduct: OrderProduct;
  fuelAmount?: number;
  setFuelAmount: (fa: number) => void;
  readingsDisabled?: boolean;
  fuelUnit?: string;
}) => {
  return (
    <>
      {readingsDisabled ? (
        <>
          <Typography className="text-[var(--grey)]" type="text-xs">
            Fuel
          </Typography>
          <Typography type="text-sm" className="flex items-center">
            {fuelAmount ?? 0} {fuelUnit}
          </Typography>
        </>
      ) : (
        <Field
          className="w-full flex-1"
          type="number"
          value={fuelAmount}
          onChange={(v) => setFuelAmount(parseFloat(v))}
        />
      )}
    </>
  );
};
